import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import pluralize from 'pluralize';
import { Link } from 'react-router-dom';
import ToolTipIcon from '../../../components/ToolTipIcon/ToolTipIcon';
import ToolTip from '../../../components/ToolTipIcon/ToolTip';
import { toggleFilters } from '../../../actions/filterActions';

function LocationActions(props) {
  const {
    showDeleteConfirmation,
    handleClickDuplicateLocationStructure,
    showAddLocationDialog,
    isAccessAllowed,
    selectedLength,
    userLocation,
    showLocationSelector,
    toggleFilters,
  } = props;
  const {
    auth: {
      user: {
        permissions: { Writer },
      },
    },
  } = props;

  if (!Writer) {
    return null;
  }

  const duplicateText = 'Duplicate Location Structure';
  const addToolText = 'Add Location';
  const deleteToolText = pluralize('Delete Location', selectedLength, false);
  const moveToolText = pluralize('Move Location', selectedLength, false);
  const homeUrl = userLocation ? `/locations?parent=${encodeURIComponent(userLocation)}` : '';

  return (
    <div
      data-test="locations-actions"
      className="grid grid-cols-[repeat(5,_max-content)] md:grid-cols-[repeat(7,_max-content)] xl:grid-cols-[repeat(14,_max-content)] gap-2 mt-8"
    >
      {isAccessAllowed && (
        <>
          <ToolTip className="add-btn" toolText="Toggle Filter">
            <button
              type="button"
              onClick={toggleFilters}
              className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
            >
              <img
                src="/assets/images/icons/filter.svg"
                alt="Health Check"
                className="w-[30px] h-[30px]"
                draggable={false}
              />
            </button>
          </ToolTip>
          <ToolTip className="add-btn" toolText={addToolText}>
            <button
              type="button"
              onClick={showAddLocationDialog}
              className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
            >
              <img
                src="/assets/images/icons/upload_icon.svg"
                alt="Health Check"
                className="w-[50px] h-[50px]"
                draggable={false}
              />
            </button>
          </ToolTip>
          {selectedLength > 0 && (
            <ToolTipIcon toolText={deleteToolText}>
              <button
                type="button"
                onClick={showDeleteConfirmation}
                className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
              >
                <img
                  src="/assets/images/icons/delete_button.svg"
                  alt="Delete"
                  className="w-[30px] h-[30px]"
                  draggable={false}
                />
              </button>
            </ToolTipIcon>
          )}
          {selectedLength > 0 && (
            <ToolTipIcon toolText={moveToolText}>
              <button
                type="button"
                onClick={showLocationSelector}
                className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
              >
                <img
                  src="/assets/images/icons/paste_button.svg"
                  alt="Delete"
                  className="w-[30px] h-[30px]"
                  draggable={false}
                />
              </button>
            </ToolTipIcon>
          )}

          {selectedLength === 1 && (
            <ToolTipIcon toolText={duplicateText}>
              <button
                type="button"
                onClick={async () => {
                  handleClickDuplicateLocationStructure();
                }}
                className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
              >
                <img
                  src="/assets/images/icons/copy_button.svg"
                  alt="Copy"
                  className="w-[30px] h-[30px]"
                  draggable={false}
                />
              </button>
            </ToolTipIcon>
          )}
        </>
      )}

      {userLocation && (
        <ToolTipIcon id="LocationsHome" toolText="Home">
          <Link
            to={homeUrl}
            type="button"
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/black_house_icon.svg"
              alt="Home"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </Link>
        </ToolTipIcon>
      )}
    </div>
  );
}

LocationActions.propTypes = {
  handleClickDuplicateLocationStructure: PropTypes.func,
  showDeleteConfirmation: PropTypes.func,
  showAddLocationDialog: PropTypes.func,
  showLocationSelector: PropTypes.func,
  isAccessAllowed: PropTypes.bool,
  selectedLength: PropTypes.number,
  userLocation: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  auth: PropTypes.shape({
    user: PropTypes.shape({
      permissions: PropTypes.shape({
        Writer: PropTypes.bool,
      }),
    }),
  }).isRequired,
  toggleFilters: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  toggleFilters,
};
const mapStateToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LocationActions);
